import { useState, type FC } from 'react';
import { ContractFormData } from '../types';

interface Props {
  onSubmit: (data: ContractFormData) => void;
  onCancel: () => void;
}

const ContractForm: FC<Props> = ({ onSubmit, onCancel }) => {
  const [formData, setFormData] = useState<ContractFormData>({
    title: '',
    description: '',
    deadline: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    reward: '',
    penalty: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.title || !formData.description) {
      alert('Заполните обязательные поля');
      return;
    }
    onSubmit(formData);
  };

  return (
    <form className="contract-form" onSubmit={handleSubmit}>
      <h2>📝 Новый контракт</h2>
      
      <div className="form-group">
        <label>Название *</label>
        <input
          type="text"
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          placeholder="Например: Сделать музыкальный клип"
          required
        />
      </div>

      <div className="form-group">
        <label>Описание *</label>
        <textarea
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          placeholder="Подробное описание задачи..."
          rows={4}
          required
        />
      </div>

      <div className="form-group">
        <label>Дедлайн *</label>
        <input
          type="date"
          value={formData.deadline}
          onChange={(e) => setFormData({ ...formData, deadline: e.target.value })}
          required
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>🏆 Награда (опционально)</label>
          <input
            type="text"
            value={formData.reward}
            onChange={(e) => setFormData({ ...formData, reward: e.target.value })}
            placeholder="Например: $50 или ужин"
          />
        </div>

        <div className="form-group">
          <label>⚠️ Штраф (опционально)</label>
          <input
            type="text"
            value={formData.penalty}
            onChange={(e) => setFormData({ ...formData, penalty: e.target.value })}
            placeholder="Например: Мыть посуду"
          />
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Отмена
        </button>
        <button type="submit" className="btn btn-primary">
          Создать контракт
        </button>
      </div>
    </form>
  );
};

export default ContractForm;
